import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { generateAemConfiguration } from './AemConfigurationUtils';
export const AemConfigurationContext = createContext({});
export const useAemConfig = () => useContext(AemConfigurationContext);
export const AemConfigurationContextWrapper = ({ children, value }) => (_jsx(AemConfigurationContext.Provider, { value: generateAemConfiguration(value), children: children }));
//# sourceMappingURL=AemConfigurationContext.js.map